import { useState, useEffect } from "react";
import { Thumbnail_View } from "./ThumbnailView";
import { LoadingComponent, Loader } from "./LoadingComponent";
import { SidebarDetailedView } from "./SideDetailedView";
import { useSelector } from "react-redux";
import { AnchorTemporaryDrawer } from "./ToggleDrawer";
import "../assets/styles/collections_contents.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faTrash,
    faPencilAlt,
    faTimes,
    faCheck
} from "@fortawesome/free-solid-svg-icons";
import { get_collections_labelList, download_files, get_labelsList, getlabelSublabelsList, createnewLabel, addLabeltoCollection, removeLabelfromCollection, deleteLabel, updateLabelSublabels, exportToCVATTool } from "../assets/constants/global_apis";
import { ConfirmationModal } from "./ConfirmationModal";
import { AlertMessageBox } from "./AlertMessage";
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { GradientCircularProgress } from "../components/Loader";
import { cvat_host } from "../assets/constants/constants";
import FileAnnotator from "./FileAnnotator";
import SubLabelList from "./SubLabelList";


const labelContainerheight = window.screen.availHeight < 800 ? (window.screen.availHeight * 0.51) : (window.screen.availHeight * 0.73)

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 900,
    bgcolor: 'background.paper',
    border: 'none',
    boxShadow: 24,
    padding: '25px'
};


export const CollectionsContentsView = ({ handleCloseFileAnnotator, handleOpenFileAnnotator, isSidebarOpen, setIsSidebarOpen }) => {
    const [contents, setContents] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [checkedState, setCheckedState] = useState([]);
    const [checkAll, setCheckAll] = useState(false);
    const collectionId = useSelector(state => state.collections.collectionId);
    const [newSubLabel, setnewSubLabel] = useState('')
    const [availableLabels, setAvailableLabels] = useState([])
    const [enableFileAnnotation, setEnableFileAnnotation] = useState(false);

    const [searchList, setSearchList] = useState([])
    const [editLabelSublabels, seteditLabelSublabels] = useState({
        editable: false,
        labels: [],
        description: [],
        editIndex: 0
    })
    const [buttonAction, setbuttonAction] = useState({
        label: {},
        event: '',
        eventMessage: ''
    })
    const [isLabelSelected, setisLabelSelected] = useState({
        labelSelected: false,
        loading: false,
        sublabels: [],
        sublabel: {}
    })
    const [collectionLabelSet, setCollectionLabelSet] = useState([])
    const [open, setOpen] = useState(false);
    const [openCVAT, setOpenCVAT] = useState(false);
    const [showAlertBox, setShowAlertBox] = useState(false);
    const [exportCVATLoader, setExportCVATLoader] = useState(false)
    const [alertMessage, setAlertMessage] = useState({
        Errortype: "Error",
        title: "",
        message: "",
    });
    const [formValues, setFormValues] = useState({
        username: '',
        password: '',
        taskName: '',
        segments: '',
        host: cvat_host,
    });
    const [errors, setErrors] = useState({});

    const validate = () => {
        const newErrors = {};

        // Username: Only alphabets
        if (formValues?.username == '') {
            newErrors.username = 'Username should not be Empty!!!';
        }
        else if (!/^[A-Za-z]+$/.test(formValues?.username)) {
            newErrors.username = 'Username should contain only alphabets.';
        }

        // Password: Any format (no validation)
        if (formValues?.password == '') {
            newErrors.password = 'Password should not be empty.';
        }

        // Task Name: Only numbers with '_' and '#'
        if (formValues?.taskName == '') {
            newErrors.taskName = 'Task Name should not be Empty!!!';
        }
        else if (!/^[0-9_#]+$/.test(formValues?.taskName)) {
            newErrors.taskName = 'Task Name should contain only numbers, "_" and "#".';
        }

        // Segments: Only numbers with '_' and '#'
        if (formValues?.segments == '') {
            newErrors.segments = 'Segments should not be Empty!!!';
        }
        else if (!/^[0-9_#]+$/.test(formValues?.segments)) {
            newErrors.segments = 'Segments should contain only numbers, "_" and "#".';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0; // returns true if no errors
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormValues({
            ...formValues,
            [name]: value,
        });
    };


    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setbuttonAction({
            label: {},
            event: '',
            eventMessage: ''
        });
        setOpen(false);
    };

    const handleOpenCVAT = () => {
        setOpenCVAT(true);
    };
    const handleCloseCVAT = () => {
        setOpenCVAT(false);
    };

    const openAlertPopup = (errorType, title, message) => {
        setAlertMessage({
            Errortype: errorType,
            title: title,
            message: message,
        });
        setShowAlertBox(true);
        setTimeout(function () {
            setShowAlertBox(false);
        }, 2000);
    };


    const get_collections_contents = () => {
        setIsLoading(true);
        setContents([]);
        setEnableFileAnnotation(false);
        const allowedExtensions = ['.pdf', '.txt', '.json'];
        setCheckAll(false);
        fetch(`/api/v1/collection/${collectionId}`, {
            method: "GET",
            headers: {
                "Content-Type": "application",
            }
        }).then(async (response) => {
            if (!response.ok) {
                const error = await response.json();
                throw error;
            }
            return response.json()
        })
            .then(data => {
                setContents(data);
                let enableFileAnnotatior = true;
                for (let i = 0; i < data.length; i++) {
                    let item = data[i]?.path
                    if (item != '') {
                        const fileExtension = item.slice(item.lastIndexOf('.')).toLowerCase();
                        if (!(allowedExtensions.includes(fileExtension))) {
                            enableFileAnnotatior = false;
                            break;
                        }
                    }
                }
                if (enableFileAnnotatior && data.length > 0) {
                    setEnableFileAnnotation(true);
                }
                setCheckedState(data.map(() => false));
                setIsLoading(false);

            })
            .catch(error => {
                setContents([]);
                setEnableFileAnnotation(false)
                setIsLoading(false);
            });
    }


    const addUUID = (data) => {
        return data.map((item) => {
            return {
                ...item,
                id: Math.random().toString(36).substring(7),
                selected: false
            }
        })
    }

    const onChangeHandler = (e) => {
        if (e.target.checked) {
            setSelectedFiles([...selectedFiles, e.target.value]);
        }
        else {
            setSelectedFiles(selectedFiles.filter((item) => item !== e.target.value));
        }
    }
    const handleChange = (index, isChecked) => {
        const updatedCheckedState = checkedState.map((item, idx) =>
            idx === index ? isChecked : item
        );
        setCheckedState(updatedCheckedState);

        // Update checkAll state if all individual checkboxes are checked/unchecked
        const allChecked = updatedCheckedState.every(item => item === true);
        const noneChecked = updatedCheckedState.every(item => item === false);
        setCheckAll(allChecked);
    };
    const getSelectedValues = () => {
        return contents
            .filter((_, index) => checkedState[index])
            .map(content => content.label);
    };
    const removeItemsFromCollection = () => {
        const selected_files = getSelectedValues();
        const filteredContents = contents.filter((content) => selected_files.includes(content.label));


        fetch(`/api/v1/collection/remove/${collectionId}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(
                filteredContents
            )
        }).then(async (response) => {
            if (!response.ok) {
                const error = await response.json();
                throw error;
            }
            return response.json()
        })
            .then(data => {
                get_collections_contents();
            })
            .catch(error => {
                console.log(error);
            })
    }

    const handleExportToCVAT = (e) => {
        e.preventDefault();
        setExportCVATLoader(true);
        if (validate()) {
            exportToCVATTool({
                collectionId: collectionId,
                username: formValues.username,
                password: formValues.password,
                taskName: formValues.taskName,
                segments: formValues.segments,
                host: encodeURI(formValues.host)
            }).then((response) => {
                if (response?.status != 200) {
                    openAlertPopup("Error", "Error", 'export_collection API got failed!!!');
                } else {
                    openAlertPopup("Success", "Success", `Export to CVAT completed`);
                    handleCloseCVAT();
                }
                setExportCVATLoader(false);
            }).catch((e) => {
                openAlertPopup("Error", "Error", e);
                handleCloseCVAT();
                setExportCVATLoader(false);
            })
        } else {
            openAlertPopup("Error", "Error", "Invalid form fields!!!");
            setExportCVATLoader(false);
        }
    }

    const handleSelectAll = (e) => {
        setCheckAll(e.target.checked);
        const newCheckState = contents.map(() => e.target.checked);
        setCheckedState(newCheckState);
    }

    useEffect(() => {
        get_collections_contents();
        setIsLoading(true);
        handleGetCollectionLabelsetDetails()
    }, [collectionId])

    const handleGetCollectionLabelsetDetails = () => {
        get_collections_labelList(collectionId).then((data) => setCollectionLabelSet(data));
        get_labelsList().then((data) => {
            setAvailableLabels(data)
            setIsLoading(false);
        });
    }

    const newLabelOnchangeHandler = (e) => {
        let regexp = /^[a-zA-Z_0-9]*$/
        if (e.target.value == '') {
            setisLabelSelected({
                labelSelected: false,
                loading: false,
                sublabels: [],
                sublabel: {}
            });
        } if (regexp.test(e.target.value)) {
            setnewSubLabel(e.target.value)
            let labelSetsnames = (collectionLabelSet && collectionLabelSet.length > 0) ? [...(collectionLabelSet.map((item, index) => item.labelSetName))] : [];
            let filteredData = availableLabels.filter((elem, index) => elem.name.includes(e.target.value) && e.target.value != '' && !(labelSetsnames.includes(elem.name)));
            setSearchList(filteredData);
        } else {
            console.log("Name should be valid")
        }
    }

    const handleSelectLabel = (sublabel, index) => {
        setisLabelSelected({
            labelSelected: true,
            loading: true,
            sublabels: [],
            sublabel: {}
        });
        setnewSubLabel(sublabel.name);
        setSearchList([]);
        getlabelSublabelsList(sublabel).then((data) => {
            setisLabelSelected({
                labelSelected: true,
                loading: false,
                sublabels: data,
                sublabel: sublabel
            });
        })
    }

    const handleAddNewSubalel = (e) => {
        if (isLabelSelected.labelSelected == true) {
            if (newSubLabel != '') {
                let requestData = {
                    "labelSetIds": [
                        isLabelSelected.sublabel.id
                    ]
                }
                addLabeltoCollection(collectionId, requestData).then((data1) => {
                    get_collections_labelList(collectionId).then((data1) => {
                        setCollectionLabelSet(data1);
                        openAlertPopup("Success", "Success", `New LabselSet Added`);
                    });
                })
            } else {
                openAlertPopup("Error", "Invalid Input", `Please Enter Valid Input`);
            }
        } else {
            if (newSubLabel != '') {
                let reqPayload = {
                    name: newSubLabel
                }
                createnewLabel(reqPayload).then((data) => {
                    if (data?.name != '') {
                        let requestData = {
                            "labelSetIds": [
                                data.id
                            ]
                        }
                        addLabeltoCollection(collectionId, requestData).then((data1) => {
                            get_collections_labelList(collectionId).then((data1) => {
                                setCollectionLabelSet(data1);
                                openAlertPopup("Success", "Success", `New LabselSet Added`);
                            });
                        })
                    }
                })
            } else {
                openAlertPopup("Error", "Invalid Input", `Please Enter Valid Input`);
            }
        }
        setnewSubLabel('');
        setisLabelSelected({
            labelSelected: false,
            loading: false,
            sublabels: [],
            sublabel: {}
        });
    }

    const handleDeleteLabel = (label) => {
        let reqpayload = {
            "labelSetIds": [
                label.labelSetId
            ]
        }
        removeLabelfromCollection(collectionId, reqpayload).then((data) => {
            let labelsList = [...collectionLabelSet].filter((item, index) => item.labelSetId != label.labelSetId);
            setCollectionLabelSet(labelsList);
            deleteLabel(label.labelSetId).then((data) => {
                let availableLabelSets = [...availableLabels].filter((item, index) => item.id != label.labelSetId);
                setAvailableLabels(availableLabelSets)
                openAlertPopup("Info", "LabelSet Deleteed", `The Labelset is Deleted from all Collections`);
            }).catch((e) => {
                openAlertPopup("Error", "Cannot Delete", `${e.message}`);
            })
        })

    }
    const handleRemoveLabel = (label) => {
        let reqpayload = {
            "labelSetIds": [
                label.labelSetId
            ]
        }
        removeLabelfromCollection(collectionId, reqpayload).then((data) => {
            let labelsList = [...collectionLabelSet].filter((item, index) => item.labelSetId != label.labelSetId);
            setCollectionLabelSet(labelsList);
        })
    }

    const handleButtonEventRemoveDelete = (event, label, index) => {
        setbuttonAction({
            label: label,
            event: event,
            eventMessage: event == 'Remove' ? <span>Do you want to remove <b>{label.labelSetName}</b> labelset from this collection?</span> : <span><b>Note:</b>This will permanently delete the <b>{label.labelSetName}</b> Labelset from All Collections! Are you sure?</span>
        });
        handleOpen();
    }
    const handleSubmitConfirmation = () => {
        if (Object.keys(buttonAction.label).length > 0) {
            if (buttonAction.event == 'Remove') {
                handleRemoveLabel(buttonAction.label);
            } else if (buttonAction.event == 'Delete') {
                handleDeleteLabel(buttonAction.label)
            }
        }
        handleClose();
    }
    const handleEditsubLabels = (label, index) => {
        seteditLabelSublabels({
            editable: true,
            labels: [...(label.labels.map((item, indx) => item.labelName))],
            description: [...(label.labels.map((item, indx) => item.labelDescription))],
            editIndex: index,
        })
    }

    const handleAddSubLabelSave = (editLabelSublabelsObj) => {
        let collectionLabel = [...collectionLabelSet];
        let payload = {
            "labels": [
                ...editLabelSublabelsObj.labels
            ],
            "description": [
                ...editLabelSublabelsObj.description
            ]
        }
        updateLabelSublabels(collectionLabel[editLabelSublabelsObj.editIndex].labelSetId, payload).then((data) => {
            get_collections_labelList(collectionId).then((data1) => {
                setCollectionLabelSet(data1)
                openAlertPopup("Success", "Success", `Labels are Updated!!!`);
                seteditLabelSublabels({
                    editable: false,
                    labels: [],
                    description: [],
                    editIndex: 0
                })
            });
        })
    }
    const handleLabelSetUnavailability = () => {
        openAlertPopup("Error", "LabelSet Not Found", "Please Add the Labelset before doing annotation!!!");
    }

    return (
        <>
            <div className="collectionContentContainer d-flex p-2 border-bottom justify-content-start align-items-center">
                <div className="">
                    <div className="input-group-text">
                        <input id="selectAll" className="form-check-input mt-0 me-2" checked={checkAll} type="checkbox" onChange={(e) => handleSelectAll(e)} />
                        <label htmlFor="selectAll" className="form-check-label">
                            {
                                checkAll ? "Unselect all" : "Select all"
                            }
                        </label>
                    </div>
                </div>
                {/* {
                  <>
                      <button className="exportCVATButton"
                          onClick={handleOpenCVAT}
                      >
                          Export to CVAT
                      </button>
                  </>
              } */}
                {enableFileAnnotation && <button className="exportCVATButton"
                    onClick={handleOpenFileAnnotator}
                >
                    File Annotation
                </button>}

                <AnchorTemporaryDrawer enableFileAnnotation={enableFileAnnotation} buttonLabel={"Edit Labels"} anchor={'right'} customButtonClass={'exportCVATButton'}>
                    <div className="editLabelContainerdrawer">
                        <div>
                            <div className='modalheadcontainer'>
                                <div className="modalHeader">
                                    Add New Labelset
                                </div>
                                <div className="addLabelContainer">
                                    <div className='inputContainer'>
                                        <input className='textInputStyle' type="text" placeholder="Labelset name.." value={newSubLabel} onChange={newLabelOnchangeHandler} />
                                        <div className='searchFilterContainer'>
                                            {searchList && searchList.length > 0 && searchList.map((item, index) => (
                                                <div className="filteredItem" key={`filtered_label_${index}`} onClick={() => handleSelectLabel(item, index)}>
                                                    {item.name}
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    <button className='customButtostyle' onClick={handleAddNewSubalel} >Add Labelset</button>
                                </div>
                                {isLabelSelected.labelSelected == true ?
                                    isLabelSelected.loading == true ?
                                        <div className="initialLoader"><Loader /></div> :
                                        (<div>
                                            <div>Selected Labelset Labels</div>
                                            <ul>
                                                {isLabelSelected?.sublabels.length > 0 ? isLabelSelected.sublabels.map((sublabel, index1) => (
                                                    <div key={`selectedlabel_sublabel${index1}`}>
                                                        <li>
                                                            {sublabel.labelName}
                                                        </li>
                                                    </div>
                                                ))
                                                    : <div className="sublabelunavailability">Labels are Not Available!!!</div>}
                                            </ul>
                                        </div>)
                                    : ''}
                                <div className="textLabel">
                                    Labelsets
                                </div>
                            </div>
                            <ConfirmationModal buttonAction={buttonAction} open={open} handleClose={handleClose} handleSubmitConfirmation={handleSubmitConfirmation} />
                            <div style={{ height: `${labelContainerheight}px` }} className='labelsContainer'>
                                {collectionLabelSet && collectionLabelSet.length > 0 && collectionLabelSet.map((label, index) => (
                                    <div key={`labels${index}`} className='labelcontainer'>
                                        <div className='labelsbox'>
                                            <div className='sublabelNames'>Labelset {' '}
                                                {/* {label.labelSetId} */}
                                                {index + 1}{' '}
                                                : {label.labelSetName}</div>
                                            <div className='buttonsDivContainer'>
                                                <button className='removebutton' onClick={() => handleButtonEventRemoveDelete('Remove', label, index)}><FontAwesomeIcon icon={faTimes} /> Remove Labelset</button>
                                                <button className='deletebutton' onClick={() => handleButtonEventRemoveDelete('Delete', label, index)}><FontAwesomeIcon icon={faTrash} /> Delete Labelset</button>
                                            </div>
                                        </div>
                                        <div className='sublabelContainer'>
                                            <div className='sublabelHeadingContainer'>
                                                <div>Labels</div>
                                                <button className='sublabelEditButton' onClick={() => handleEditsubLabels(label, index)}><FontAwesomeIcon icon={faPencilAlt} /></button>
                                            </div>
                                            <ul style={{ marginBottom: `${editLabelSublabels.editable && index == editLabelSublabels.editIndex ? '0px' : '1rem'}` }}>
                                                <SubLabelList editLabelSublabels={editLabelSublabels} seteditLabelSublabels={seteditLabelSublabels} handleAddSubLabelSave={handleAddSubLabelSave} openAlertPopup={openAlertPopup} index={index} label={label} handleGetCollectionLabelsetDetails={handleGetCollectionLabelsetDetails} />

                                            </ul>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </AnchorTemporaryDrawer>
                {
                    checkedState.some((item) => item) &&
                    <>
                        <button className="btn btn-danger ms-2" onClick={() => removeItemsFromCollection()}>
                            Remove from collection
                        </button>
                    </>
                }
                {
                    checkedState.some((item) => item) &&
                    <button className="btn btn-dark" style={{ marginLeft: '1%' }} onClick={() => download_files(contents.filter((_, index) => checkedState[index]))}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 me-2">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
                        </svg>
                        Download file
                    </button>
                }
            </div>
            <div className="position-relative" style={{ height: "calc(100vh - 115px)", overflow: "auto" }}>
                <div className="container-fluid g-2 mt-2">
                    <div className="row row-cols-1 row-cols-sm-2 row-cols-md-6 g-2">
                        {
                            contents.length > 0 &&
                            contents.map((content, index) => (
                                <div className={`col mt-2 }`} key={index} title={content.id}
                                >
                                    <div className={`form-check position-relative cursor-pointer ${checkedState[index] ? "checked" : ""}`}>
                                        {/* <input
                                          className="form-check-input file-checkbox"
                                          type="checkbox"
                                          value={content.label}
                                          onChange={(e) => handleChange(index, e.target.checked)}
                                          id={"fileCheck-" + collectionId + "-" + index}
                                          name={'collectionId-' + collectionId}
                                          checked={checkedState[index]}
                                      /> */}

                                        <label className="form-check-label d-flex flex-column" htmlFor={"fileCheck-" + collectionId + "-" + index}>
                                            <Thumbnail_View path={{ content, index, collectionId, collectionLabelSet, handleLabelSetUnavailability, handleFileSelect: handleChange, checkedState: checkedState }} setIsSidebarOpen={setIsSidebarOpen} isSidebarOpen={isSidebarOpen} />
                                        </label>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
                {
                    contents.length === 0 &&
                    <div className="d-flex justify-content-center align-items-center h-100">
                        <span>No data available</span>
                    </div>
                }
                {isLoading && <LoadingComponent />}
            </div>
            <Modal
                open={openCVAT}
                onClose={handleCloseCVAT}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
                className="cvatModalContainer"
            >
                <Box sx={{ ...style }}>
                    <div className="modal-header border-0">
                        <h1 className="modal-title fs-5" id="createCollectionModalLabel">Export to CVAT Form</h1>
                        <button type="button" className="btn-close" onClick={handleCloseCVAT}></button>
                    </div>
                    <div className="modal-body">
                        {exportCVATLoader && (<div className="cvat_loader_container">
                            <GradientCircularProgress />
                        </div>
                        )}
                        <form onSubmit={handleExportToCVAT} style={{ opacity: exportCVATLoader ? '0.5' : '' }}>
                            <div className="cvatInputContainer">
                                <label>Username: <span className="non-empty-field">*</span> <span className="error-message">{errors.username && errors.username}</span></label>
                                <input
                                    type="text"
                                    name="username"
                                    disabled={exportCVATLoader}
                                    className="cvatFormInput"
                                    placeholder="Please Enter CVAT UseName"
                                    value={formValues.username}
                                    onChange={handleInputChange}
                                />
                            </div>

                            <div className="cvatInputContainer">
                                <label>Password: <span className="non-empty-field">*</span> <span className="error-message">{errors.password && errors.password}</span></label>
                                <input
                                    type="password"
                                    name="password"
                                    disabled={exportCVATLoader}
                                    className="cvatFormInput"
                                    placeholder="Please Enter CVAT Password"
                                    value={formValues.password}
                                    onChange={handleInputChange}
                                />
                                {/* No validation message needed for password */}
                            </div>

                            <div className="cvatInputContainer">
                                <label>Task Name: <span className="non-empty-field">*</span> <span className="error-message">{errors.taskName && errors.taskName}</span></label>
                                <input
                                    type="text"
                                    name="taskName"
                                    disabled={exportCVATLoader}
                                    className="cvatFormInput"
                                    placeholder="Please Enter Task Name"
                                    value={formValues.taskName}
                                    onChange={handleInputChange}
                                />

                            </div>

                            <div className="cvatInputContainer">
                                <label>Segments: <span className="non-empty-field">*</span>  <span className="error-message">{errors.segments && errors.segments}</span></label>
                                <input
                                    type="text"
                                    name="segments"
                                    disabled={exportCVATLoader}
                                    className="cvatFormInput"
                                    placeholder="Please Enter Segment Name"
                                    value={formValues.segments}
                                    onChange={handleInputChange}
                                />
                            </div>

                            <div className="cvatInputContainerhost">
                                <label>Host:</label>
                                <input
                                    type="text"
                                    className="cvatFormInput"
                                    disabled={exportCVATLoader}
                                    name="host"
                                    placeholder="Please Enter Host Name"
                                    value={formValues.host}
                                    onChange={handleInputChange}
                                />
                            </div>

                            <button disabled={exportCVATLoader} className="btn btn-sm btn-primary cvat-submit" type="submit">Submit</button>
                        </form>

                    </div>
                </Box>
            </Modal>
            <SidebarDetailedView isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />
            <div className='annotationLabelSetAlertcontainer'>
                <AlertMessageBox
                    showAlertBox={showAlertBox}
                    setShowAlertBox={setShowAlertBox}
                    alertMessage={alertMessage}
                />
            </div>

        </>
    )

}